import React from 'react';
import Solutions from './Solutions';
import Contact from './Contact';
import Staff from './Staff';

const Home = () => {
  return (
    <>
      <Solutions />
      <Contact />
      <Staff />
    </>
  );
};

export default Home;
